module["exports"] = [
  "####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/postcode.js
// module id = 1116
// module chunks = 0